/**
 * FCT Account API
 * FCT Account API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: areche@ilernaonline.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The ProvinceItem model module.
 * @module model/ProvinceItem
 * @version 1.0.0
 */
class ProvinceItem {
    /**
     * Constructs a new <code>ProvinceItem</code>.
     * @alias module:model/ProvinceItem
     */
    constructor() { 
        
        ProvinceItem.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>ProvinceItem</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/ProvinceItem} obj Optional instance to populate.
     * @return {module:model/ProvinceItem} The populated <code>ProvinceItem</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ProvinceItem();

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
        }
        return obj;
    }


}

/**
 * ID de la provincia
 * @member {Number} id
 */
ProvinceItem.prototype['id'] = undefined;

/**
 * Nombre de la provincia
 * @member {String} name
 */
ProvinceItem.prototype['name'] = undefined;






export default ProvinceItem;

